// src/componentes/Tarjeta.js
import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../servicios/store';
import './Tarjeta.css';

const Tarjeta = ({ titulo, descripcion, imagen, enlace }) => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  const handleClick = (e) => {
    e.preventDefault();
    
    if (enlace.startsWith('/')) {
      // Ruta interna protegida
      if (!currentUser) {
        navigate('/login');
        return;
      }
      navigate(enlace);
    } else {
      // Comportamiento original para enlaces externos
      window.open(enlace, '_blank');
    }
  };

  return (
    <Card className="tarjeta-container shadow-sm">
      {imagen && (
        <Card.Img 
          variant="top" 
          src={imagen} 
          alt={titulo}
          className="tarjeta-imagen"
        />
      )}
      <Card.Body className="d-flex flex-column">
        <Card.Title className="tarjeta-titulo">{titulo}</Card.Title>
        <Card.Text className="tarjeta-descripcion">{descripcion}</Card.Text>
        {enlace && (
          <Button 
            onClick={handleClick}
            className="tarjeta-boton mt-auto"
            style={{
              backgroundColor: 'var(--color-secundario)',
              borderColor: 'var(--color-secundario)'
            }}
          >
            Ver contenido
          </Button>
        )}
      </Card.Body>
    </Card>
  );
};

export default Tarjeta;